import * as types from "./types";
import {
    getJournalEntryAxios, 
    getJournalEntryIDAxios,
    deleteJournalEntryAxios,
    postJournalEntryAxios,
    putJournalEntryAxios,
} from "./services";

export async function getJournalEntryListAction({commit}) {
    commit(types.LOADING_JOURNALENTRY, true);
    try {
        const {data} = await getJournalEntryAxios();
        commit(types.GET_JOURNALENTRY_LIST, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRY, false);
    }
   
}

export async function getJournalEntryIDAction({commit},payload) {
    commit(types.LOADING_JOURNALENTRY, true);
    try {
        const {data} = await getJournalEntryIDAxios(payload);
        commit(types.GET_JOURNALENTRY_ID, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRY, false);
    }
}

export async function getLinesByJournalEntryIDAction({commit},payload) {
  commit(types.LOADING_JOURNALENTRY, true);
  try {
      const {data} = await getJournalEntryLinesAxios(payload);
      commit(types.GET_JOURNALENTRY_ID, data.result);
  }
  catch(e) {
     
      throw e;
  }
  finally {
      commit(types.LOADING_JOURNALENTRY, false);
  }
}

export async function removeJournalEntryAction({commit}, payload) {
    commit(types.LOADING_JOURNALENTRY, true);
    try {
        await deleteJournalEntryAxios(payload);
        commit(types.REMOVE_JOURNALENTRY, payload);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_JOURNALENTRY, false);
    }
}

export async function addJournalEntryAction({ commit }, payload) {
    commit(types.LOADING_JOURNALENTRY, true);
    try {
      const { data } = await postJournalEntryAxios(payload);
      commit(types.ADD_JOURNALENTRY, payload);
      return data;
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_JOURNALENTRY, false);
    }
  }

  export async function updateJournalEntryAction({ commit }, payload) {
    commit(types.LOADING_JOURNALENTRY, true);
    try {
      const { data } = await putJournalEntryAxios(payload);
      commit(types.UPDATE_JOURNALENTRY, payload);
      return data;
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_JOURNALENTRY, false);
    }
  }